import React from 'react';
import { format, isSameDay, isSameMonth } from 'date-fns';
import { useTranslation } from 'react-i18next';
import Icon from '../../components/Icon';
import { dateLocale, eventTime, eventsOfDay, monthMatrix, weekdayLabels } from '../calendarUtils';

const MAX_VISIBLE = 3;

// Месячная сетка: 6 недель, события цветными плашками календаря.
const MonthView = ({ month, events, selectedDate, locale, colorOf, onSelectDate, onOpenEvent }) => {
  const { t } = useTranslation();
  const days = monthMatrix(month);
  const today = new Date();

  return (
    <div className="cal-month">
      <div className="cal-weekdays">
        {weekdayLabels(locale).map((label) => (
          <span key={label}>{label}</span>
        ))}
      </div>

      <div className="cal-month-grid">
        {days.map((day) => {
          const dayEvents = eventsOfDay(events, day);
          const outside = !isSameMonth(day, month);
          const selected = isSameDay(day, selectedDate);

          return (
            <div
              key={day.toISOString()}
              className={`cal-cell${outside ? ' outside' : ''}${selected ? ' selected' : ''}`}
              onClick={() => onSelectDate(day)}
              role="presentation"
            >
              <span className={`cal-cell-date${isSameDay(day, today) ? ' today' : ''}`}>
                {format(day, 'd', { locale: dateLocale(locale) })}
              </span>

              <div className="cal-cell-events">
                {dayEvents.slice(0, MAX_VISIBLE).map((event) => (
                  <button
                    key={event.id}
                    type="button"
                    className="cal-event"
                    style={{ background: colorOf(event) }}
                    onClick={(e) => {
                      e.stopPropagation();
                      onOpenEvent(event);
                    }}
                    title={event.title}
                  >
                    <Icon name="clock" size={11} />
                    <span className="cal-event-title">{event.title}</span>
                    <span className="cal-event-time">{eventTime(event, locale)}</span>
                  </button>
                ))}

                {dayEvents.length > MAX_VISIBLE && (
                  <span className="cal-more">{t('calendar.more', { count: dayEvents.length - MAX_VISIBLE })}</span>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default MonthView;
